import axios from "axios";
export const readRecord = (collection: string, id: string) => {
  return axios.get(`${process.env.REACT_APP_API_URL}/api/${collection}/${id}`);
};
